import React, { useEffect, useMemo, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, FormHelperText, Autocomplete, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { ClothStockMaster, clothStockReg, InwardMaster } from '../TitleList';
import styled, { inputImages, inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { fetchClothData } from '../../Store/PHPSlice/Cloth';
import { fetchRackData } from '../../Store/PHPSlice/Rack';
import { createClothStockEntry } from '../../Store/PHPSlice/clothStock';
import { selectCloths, selectlocationdata, selectRack } from '../Selectors/Master/ItemSelectors';
import { errorStyles } from '../../Utils/table';
import { fetchLocationData } from '../../Store/PHPSlice/Transport';
import Dropdown from '../FieldsComponents/Dropdown';

const ClothStkEntry = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: '',
        clothId: '',
        meter: 0,
        rack: '',
        bale: '',
        locId: '',
        userId: userdata?.ID
    });

    const [errors, setErrors] = useState({});
    const [tableData, setTableData] = useState([]);
    const dispatch = useDispatch();
    const cloths = useSelector(selectCloths);
    const rack = useSelector(selectRack);
    const locdata = useSelector(selectlocationdata);

    useEffect(() => {
        dispatch(fetchClothData());
        dispatch(fetchRackData());
        dispatch(fetchLocationData());
    }, [dispatch]);

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleAddData = () => {

        if (formData.dt.trim() === "") {
            alert("Select Date");
        } else if (formData.clothId.trim() === "") {
            alert("Select Cloth");
        } else if (formData.rack.trim() === "") {
            alert("Select rack");
        } else if (formData.locId.trim() === "") {
            alert("Select location");
        } else {

            const selectCloth = cloths?.data?.find((val) => val.ID == formData.clothId);
            const clothNm = selectCloth ? `${selectCloth.clothNm} ${selectCloth.model} ${selectCloth.color} ${selectCloth.shadeNo} ${selectCloth.panna_size}` : null;
            const locNm = locdata?.data?.find(item => item.ID === formData.locId)?.locNm;
            const tableValues = {
                dt: formData.dt,
                clothId: formData.clothId,
                cloth: clothNm,
                rack: formData.rack,
                meter: formData.meter,
                locNm: locNm,
                locId: formData.locId,
                baleNo: formData.bale
            };
            setTableData([...tableData, tableValues]);

            setFormData(prev => ({
                ...prev,
                dt: '',
                clothId: '',
                rack: '',
                meter: '',
                bale: '',
                locId: ''
            }));
        }
    };

    const handleMeterChange = (index, value) => {
        setTableData(prevData =>
            prevData.map((item, i) =>
                i === index ? { ...item, meter: value } : item
            )
        );
    };

    const handleBaleChange = (index, value) => {
        setTableData(prevData =>
            prevData.map((item, i) =>
                i === index ? { ...item, baleNo: value } : item
            )
        );
    };

    const handleCheckboxChange = (index) => {
        setTableData(prevData =>
            prevData.map((item, i) =>
                i === index ? { ...item, checked: !item.checked } : item
            )
        );
    };

    const deleteSelectedRows = () => {
        setTableData(prevData => prevData.filter(item => !item.checked));
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.dt) newErrors.dt = 'Date is required';
        if (!formData.clothId) newErrors.clothId = 'Cloth is required';
        if (!formData.rack) newErrors.rack = 'Rack is required';
        if (!formData.meter) newErrors.meter = 'Meter is required';
        return newErrors;
    };

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    function postObj(formData, tableData) {
        const data = {
            tableData: tableData,
            userId: formData.userId
        };
        return data;
    }

    const handleLumpClick = (index, clothId, mtr, locNm) => {
        // setCurrentIndex(index);
        // Construct the URL with query parameters or use a placeholder route
        const id = index + 1;

        // const url = `/LumpMtrEntry2/${id}-${clothId}-${mtr}-${locNm}`;
        // console.log(tableRows);
        const arr = [id, clothId, mtr, locNm]
        const url = `/LumpMtrEntry2/${arr}`;
        window.open(url, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // const validationErrors = validate();
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }
        // if (formData.dt == '') {
        //     alert('Select the Date');
        // }
        const invalidRows = tableData.filter(row => !row.baleNo || !row.meter);

        if (invalidRows.length > 0) {
            alert("Please Enter value in both Bale and Bale Mtr.");
            return;
        }

        const postData = postObj(formData, tableData);
        // console.log(postData);
        dispatch(createClothStockEntry(postData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Cloth Stock Added");
                alert("Cloth Stock Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    const handleResend = (resendData) => {
        // console.log("Received data from child window:", resendData);
        if (resendData) {
            const index = resendData?.index;
            const totmtr = resendData?.totmtr;
            const updateTableData = [...tableData];

            updateTableData[index].meter = totmtr;
            setTableData(updateTableData);

        }
        // Process the data (e.g., update state)
    };

    window.handleResendFromChild2 = handleResend;
    // console.log(tableData)

    const dropdownlistfirst = [
        {
            label: 'Location',
            id: 'locId',
            options: locdata?.data || [],
            value: formData.locId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.ID : '' } }, 'locId'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    return (
        <>
            {/* <Titlebar data={ClothStockMaster} /> */}
            <Titlebar data={clothStockReg} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Manual Cloth Stock Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='dt' >Date:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id='dt'
                                                    name='dt'
                                                    type='date'
                                                    value={formData.dt}
                                                    onChange={handleDateChange}
                                                    inputProps={{ style: styled.inputDate }}
                                                    sx={inputStyles}
                                                />
                                                {errors.dt && <FormHelperText style={errorStyles}>{errors.dt}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="clothId">Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    id="clothId"
                                                    name="clothId"
                                                    options={cloths.data}
                                                    getOptionLabel={(option) => `${option.clothNm} ${option.model} ${option.color} ${option.shadeNo} ${option.panna_size}`}
                                                    value={cloths.data.find(item => item.ID === formData.clothId) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'clothId', value: newValue ? newValue.ID : '' } }, 'clothId')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder="Select an option"
                                                            error={!!errors.clothId}
                                                            helperText={errors.clothId}
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="rack">Rack :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    id="rack"
                                                    name="rack"
                                                    options={rack?.data?.map((item) => item.rackNm)}
                                                    value={formData.rack || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'rack', value: newValue } }, 'rack')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder="Select an option"
                                                            error={!!errors.rack}
                                                            helperText={errors.rack}
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                {
                                    dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }
                                {/* {[

                                    { label: 'Meter', name: 'meter' },
                                    { label: 'Bale No', name: 'bale' }

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'readOnly' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.inputImg, readOnly: true }}
                                                            sx={inputImages}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))} */}

                                <Grid item xs={6}>
                                    <Button variant="contained" color="primary"
                                        onClick={handleAddData}
                                    >
                                        Add
                                    </Button>
                                </Grid>

                                {Array.isArray(tableData) && tableData.length > 0 &&
                                    <>
                                        <Grid item xs={6}>
                                            <Button variant="contained" color="primary"
                                                onClick={deleteSelectedRows}
                                            >
                                                Delete
                                            </Button>
                                        </Grid>

                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table style={isDesktop ? { width: '70%' } : { width: '100%' }}>
                                                <TableBody>

                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Select</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Sr.No.</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Date</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Cloth</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Rack</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Location</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Bale</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Bale Mtr.</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Lump</TableCell>
                                                    </TableRow>
                                                    {
                                                        tableData.map((item, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={item.checked}
                                                                        onChange={() => handleCheckboxChange(index)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{index + 1}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.dt}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.cloth}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.rack}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.locNm}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        value={item.baleNo}  // Ensure value is either the number or an empty string
                                                                        name="baleNo"
                                                                        style={{ width: '100px', padding: '1px' }}
                                                                        onChange={(e) => handleBaleChange(index, e.target.value)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        value={item.meter}  // Ensure value is either the number or an empty string
                                                                        name="meter"
                                                                        style={{ width: '100px', padding: '1px' }}
                                                                        onChange={(e) => handleMeterChange(index, e.target.value)}
                                                                    />
                                                                </TableCell>
                                                                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.baleNo}</TableCell> */}
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>

                                                                    <Button variant="contained" color="primary" size='small'
                                                                        onClick={() => handleLumpClick(index, item.clothId, item.meter, item.locNm)}
                                                                        disabled={item.meter === 0}
                                                                    >
                                                                        Add
                                                                    </Button>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </>
                                }

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={tableData.length === 0}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default ClothStkEntry;
